import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_SETTINGS } from "constants/readabilityThresholds";

const initialState = { ...DEFAULT_SETTINGS };

export const thresholdsSlice = createSlice({
  name: "thresholds",
  initialState,
  reducers: {
    setThresholds: (_, action) => {
      return { ...action.payload };
    },
  },
});

export const { setThresholds } = thresholdsSlice.actions;

export default thresholdsSlice.reducer;
